import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { environments } from '@/environments';
import {
  COOKIE_ACCESS_TOKEN,
  COOKIE_ID_TOKEN,
  TOKEN_EXPIRES_IN,
  setAccessToken,
  setIDToken,
} from '@/helpers/cookie';

/*
- Login on TEOD (handleLogin): calls authorizeUrl() which stores the verifier in TEOD's sessionStorage, then reads it back and embeds it as cv in the OAuth state before redirecting
- Callback on staging (Callback.tsx): decodes the state, finds cv, writes it into staging's sessionStorage before useExchangeAccessToken fires — so js-pkce finds the verifier and completes the token exchange
- Relay: data is now populated, teodUrl is detected, tokens are relayed to mr-256.backoffice-qcd-module.pages.dev/auth/relay#tokens
- TeodCallback: sets cookies on .backoffice-qcd-module.pages.dev and redirects to the app
*/

const TeodCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = params.get(COOKIE_ACCESS_TOKEN);
    const idToken = params.get(COOKIE_ID_TOKEN);
    const expiresIn = params.get(TOKEN_EXPIRES_IN);

    if (accessToken) {
      const cookieOptions = {
        expires: expiresIn ? `${expiresIn}s` : undefined,
        domain: environments.cookieDomain,
      };

      setAccessToken(accessToken, cookieOptions);

      if (idToken) {
        setIDToken(idToken, cookieOptions);
      }
    }

    const lastLocation = localStorage.getItem('lastLocation') || '/';
    window.location.replace(lastLocation);
  }, []);

  return (
    <Stack
      sx={{
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        py: 8,
      }}
    >
      <Typography variant="body2">Signing you in, please wait ...</Typography>
    </Stack>
  );
};

export default TeodCallback;
